export default {
  isNavigatingBack: false,
  resultsScrollTop: 0,
  search: {
    isLoading: false,
    results: [],
    searchTerm: '',
    timestamp: null,
  },
  selectedAnswer: null,
  timeline: [],
  isThrottled: false,
  searchTerm: null,
};
